import gsap from 'gsap';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import { GetBy } from '../_app/cuchillo/core/Element';
import Scroll_Item from '../_app/cuchillo/scroll/Scroll_Item';
import { SplitText } from 'gsap/all';
import { Maths } from '../_app/cuchillo/utils/Maths';

// Rangs del progrés de l'element (el MATEIX que --progress = this.progress).
const SHOW_RANGE = [0.25, 0.75]; // show
const HIDE_RANGE = [0.5, 1];     // hide

// Reveal de text per scroll: cada unitat (paraula o grup de HAHA) apareix amb el show i
// desapareix amb el hide, distribuïda al llarg del progrés. Els HAHA a més fan scale 2.2→1.
class ScrollItem__ProductNarrative extends Scroll_Item {

    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);

        this._setupUnits(__link);

        this.onMove = () => {
            const showP = Maths.clamp(Maths.normalize(SHOW_RANGE[1], SHOW_RANGE[0], this.progress), 0, 1);
            const hideP = Maths.clamp(Maths.normalize(HIDE_RANGE[1], HIDE_RANGE[0], this.progress), 0, 1);
            this._draw(showP, hideP);
        };
    }

    _setupUnits(__link) {
        this._units = [];
        this.totalItems = 0;
        this.inc = 0;

        const container = GetBy.class("__textShow", __link)[0];
        if (!container) return;

        // Paraules
        const words = new SplitText(container, { type: 'words', wordsClass: 'word-child' }).words;

        // HAHA: cada svg (ha-wrap) és una unitat pròpia — compta com una "paraula" més,
        // per seguir el mateix ritme de reveal que la resta del bloc.
        const svgs = [...GetBy.selector('svg', container)];

        const hahaUnits = svgs.map(svg => ({ type: 'haha', el: svg, svgs: [svg] }));
        const wordUnits = words.map(el => ({ type: 'word', el }));

        // Seqüència ordenada per posició de document.
        this._units = [...wordUnits, ...hahaUnits].sort((a, b) =>
            (a.el.compareDocumentPosition(b.el) & Node.DOCUMENT_POSITION_FOLLOWING) ? -1 : 1
        );
        this.totalItems = this._units.length;
        this.inc = this.totalItems > 0 ? 1 / this.totalItems : 0;

        this._draw(0, 0); // estat inicial: tot amagat
    }

    _draw(showP, hideP) {
        let p0 = 0;
        let p1 = this.inc;

        for (let i = 0; i < this.totalItems; i++) {
            const showO = Maths.clamp(Maths.normalize(p1, p0, showP), 0, 1);
            const hideO = Maths.clamp(Maths.normalize(p1, p0, hideP), 0, 1);
            const vis = Maths.clamp(showO - hideO, 0, 1); // apareix amb show, marxa amb hide
            const u = this._units[i];

            if (u.type === 'haha') {
                gsap.set(u.svgs, { opacity: vis, scale: 2.2 - 1.2 * showO });
            } else {
                u.el.style.opacity = vis;
            }

            p0 = p1;
            p1 += this.inc;
        }
    }
}

Scroll._registerClass('ProductNarrative', ScrollItem__ProductNarrative);

export default ScrollItem__ProductNarrative;
